import { render, staticRenderFns } from "./AutocompleteProfessionGroupAdmin.vue?vue&type=template&id=6d466380"
import script from "./AutocompleteProfessionGroupAdmin.vue?vue&type=script&lang=js"
export * from "./AutocompleteProfessionGroupAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports